import { forwardRef } from 'react';
import SvgIcon from 'shell/components/SvgIcon';

export default forwardRef((props, ref) => {
    return (
        <SvgIcon ref={ref} {...props}>
            <path d='M20.9925 9.61641C20.8125 13.3527 18.2118 15.2346 14.9813 18.0208C13.2805 19.4916 10.7428 19.4915 9.03302 18.0299C5.82944 15.2894 3.13879 13.371 3.00381 9.50678C2.83283 4.64685 8.4571 2.65539 11.6517 6.62007C11.8227 6.83931 12.1736 6.83017 12.3536 6.61092C15.5392 2.62798 21.2354 4.64686 20.9925 9.61641Z' />
        </SvgIcon>
    );
});
